<div class="one" fxLayout="column" [formGroup]="matterLeasingForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-checkbox fxFlex="100" class="pr-1" formControlName="LEASERECEIVED">
      Lease Received
    </mat-checkbox>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Date Executed</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'DATEEXECUTED')"
        formControlName="DATEEXECUTEDTEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'DATEEXECUTED')"
        matInput
        name="DateExecutede"
        [matDatepicker]="DateExecutede"
        matTooltip="{{ toolTipList ? toolTipList.DATEEXECUTED?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="DateExecutede"></mat-datepicker-toggle>
      <mat-datepicker #DateExecutede></mat-datepicker>
      @if (testBool && toolTipList.DATEEXECUTED) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.DATEEXECUTED.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.DATEEXECUTED?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Valid Until</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'VALIDUNTIL')"
        formControlName="VALIDUNTILTEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'VALIDUNTIL')"
        matInput
        matTooltip="{{ toolTipList ? toolTipList.VALIDUNTIL?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        name="ValidUntil"
        [matDatepicker]="ValidUntil"
      />
      <mat-datepicker-toggle matSuffix [for]="ValidUntil"></mat-datepicker-toggle>
      <mat-datepicker #ValidUntil></mat-datepicker>
      @if (testBool && toolTipList.VALIDUNTIL) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.VALIDUNTIL.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.VALIDUNTIL?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Executed By Lessors</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'EXECUTIONDATEBYLESSOR')"
        formControlName="EXECUTIONDATEBYLESSORTEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'EXECUTIONDATEBYLESSOR')"
        matInput
        matTooltip="{{ toolTipList ? toolTipList.EXECUTIONDATEBYLESSOR?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        name="ExecutedByLessors"
        [matDatepicker]="ExecutedByLessors"
      />
      <mat-datepicker-toggle matSuffix [for]="ExecutedByLessors"></mat-datepicker-toggle>
      <mat-datepicker #ExecutedByLessors></mat-datepicker>
      @if (testBool && toolTipList.EXECUTIONDATEBYLESSOR) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.EXECUTIONDATEBYLESSOR.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.EXECUTIONDATEBYLESSOR?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Executed By Lessee</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'EXECUTIONDATEBYLESSEE')"
        formControlName="EXECUTIONDATEBYLESSEETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'EXECUTIONDATEBYLESSEE')"
        matInput
        matTooltip="{{ toolTipList ? toolTipList.EXECUTIONDATEBYLESSEE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        name="ExecutedByLessee"
        [matDatepicker]="ExecutedByLessee"
      />
      <mat-datepicker-toggle matSuffix [for]="ExecutedByLessee"></mat-datepicker-toggle>
      <mat-datepicker #ExecutedByLessee></mat-datepicker>
      @if (testBool && toolTipList.EXECUTIONDATEBYLESSEE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.EXECUTIONDATEBYLESSEE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.EXECUTIONDATEBYLESSEE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Lease Start Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'LEASECOMMENCEMENTDATE')"
        formControlName="LEASECOMMENCEMENTDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'LEASECOMMENCEMENTDATE')"
        matInput
        matTooltip="{{ toolTipList ? toolTipList.LEASECOMMENCEMENTDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        name="LeaseStartDate"
        [matDatepicker]="LeaseStartDate"
      />
      <mat-datepicker-toggle matSuffix [for]="LeaseStartDate"></mat-datepicker-toggle>
      <mat-datepicker #LeaseStartDate></mat-datepicker>
      @if (testBool && toolTipList.LEASECOMMENCEMENTDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.LEASECOMMENCEMENTDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.LEASECOMMENCEMENTDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Lease End Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'LEASETERMINATIONDATE')"
        formControlName="LEASETERMINATIONDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'LEASETERMINATIONDATE')"
        matInput
        matTooltip="{{ toolTipList ? toolTipList.LEASETERMINATIONDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        name="LeaseEndDate"
        [matDatepicker]="LeaseEndDate"
      />
      <mat-datepicker-toggle matSuffix [for]="LeaseEndDate"></mat-datepicker-toggle>
      <mat-datepicker #LeaseEndDate></mat-datepicker>
      @if (testBool && toolTipList.LEASETERMINATIONDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.LEASETERMINATIONDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.LEASETERMINATIONDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- <mat-form-field appearance="outline" fxFlex="100" class="pr-1">
    <mat-label>Term Of Lease </mat-label>
    <textarea matInput matTooltip="{{(toolTipList)?toolTipList.TERMOFLEASE?.HOVER:''}}" [matTooltipPosition]="toolTipPostion" formControlName="TERMOFLEASE"></textarea>
    <div  *ngIf="testBool && toolTipList.TERMOFLEASE" class="tooltip-wrap" ><input id="myInput" readonly disabled value="{{(toolTipList)?toolTipList.TERMOFLEASE.COPYVALUE:''}}"><mat-icon (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.TERMOFLEASE?.COPYVALUE:'')">file_copy</mat-icon></div>
  </mat-form-field> -->

    <mat-form-field appearance="outline" class="full-width pr-1" fxFlex="100">
      <mat-label>Term Of Lease</mat-label>

      <textarea
        matInput
        formControlName="TERMOFLEASE"
        [matTooltip]="toolTipList?.TERMOFLEASE?.HOVER || ''"
        [matTooltipPosition]="toolTipPostion"
        rows="4"
        (keydown.enter)="$event.stopImmediatePropagation()"
      ></textarea>
      @if (testBool && toolTipList.TERMOFLEASE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.TERMOFLEASE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.TERMOFLEASE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- <mat-form-field appearance="outline" fxFlex="100" class="pr-1">
  <mat-label>Permitted Use </mat-label>
  <textarea matInput matTooltip="{{(toolTipList)?toolTipList.PERMITTEDUSE?.HOVER:''}}" [matTooltipPosition]="toolTipPostion" formControlName="PERMITTEDUSE"></textarea>
  <div  *ngIf="testBool && toolTipList.PERMITTEDUSE" class="tooltip-wrap" ><input id="myInput" readonly disabled value="{{(toolTipList)?toolTipList.PERMITTEDUSE.COPYVALUE:''}}"><mat-icon (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.PERMITTEDUSE?.COPYVALUE:'')">file_copy</mat-icon></div>
</mat-form-field> -->

    <mat-form-field appearance="outline" class="matter-textarea-wrapper pr-1" fxFlex="100">
      <mat-label>Permitted Use</mat-label>

      <textarea
        matInput
        formControlName="PERMITTEDUSE"
        [matTooltip]="toolTipList?.PERMITTEDUSE?.HOVER || ''"
        [matTooltipPosition]="toolTipPostion"
        rows="4"
        (keydown.enter)="$event.stopImmediatePropagation()"
      ></textarea>
      @if (testBool && toolTipList.PERMITTEDUSE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PERMITTEDUSE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.PERMITTEDUSE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" class="checkbox-row">
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Lettable SqM</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.LETTABLEAREASQM?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="LETTABLEAREASQM"
      />
      @if (testBool && toolTipList.LETTABLEAREASQM) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.LETTABLEAREASQM.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.LETTABLEAREASQM?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-checkbox class="checkbox-width pr-1" formControlName="RELATESTORETIREMENTVILLAGE">
      Relates To Retirement Village
    </mat-checkbox>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" class="checkbox-row">
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Disclosure Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'DISCLOSUREDATE')"
        formControlName="DISCLOSUREDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'DISCLOSUREDATE')"
        matInput
        matTooltip="{{ toolTipList ? toolTipList.DISCLOSUREDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        name="DisclosureDate"
        [matDatepicker]="DisclosureDate"
      />
      <mat-datepicker-toggle matSuffix [for]="DisclosureDate"></mat-datepicker-toggle>
      <mat-datepicker #DisclosureDate></mat-datepicker>
      @if (testBool && toolTipList.DISCLOSUREDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.DISCLOSUREDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.DISCLOSUREDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-checkbox class="checkbox-width pr-1" formControlName="RETAILSHOPLEASE">
      Retail Shop Leases
    </mat-checkbox>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Registration Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'REGISTRATIONDATE')"
        formControlName="REGISTRATIONDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'REGISTRATIONDATE')"
        matInput
        matTooltip="{{ toolTipList ? toolTipList.REGISTRATIONDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        name="RegistrationDate"
        [matDatepicker]="RegistrationDate"
      />
      <mat-datepicker-toggle matSuffix [for]="RegistrationDate"></mat-datepicker-toggle>
      <mat-datepicker #RegistrationDate></mat-datepicker>
      @if (testBool && toolTipList.REGISTRATIONDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.REGISTRATIONDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.REGISTRATIONDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Registered Number</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.LEASINGREGISTEREDNUMBER?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="LEASINGREGISTEREDNUMBER"
      />
      @if (testBool && toolTipList.LEASINGREGISTEREDNUMBER) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.LEASINGREGISTEREDNUMBER.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.LEASINGREGISTEREDNUMBER?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="100" class="pr-1">
      <mat-label>Access Outside Trading Hours</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.ACCESSOUTSIDETRADINGHOURS?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="ACCESSOUTSIDETRADINGHOURS"
      />
      @if (testBool && toolTipList.ACCESSOUTSIDETRADINGHOURS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.ACCESSOUTSIDETRADINGHOURS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.ACCESSOUTSIDETRADINGHOURS?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Option Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'OPTIONDATE')"
        formControlName="OPTIONDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'OPTIONDATE')"
        matInput
        matTooltip="{{ toolTipList ? toolTipList.OPTIONDATE : '' }}"
        [matTooltipPosition]="toolTipPostion"
        name="OptionDate"
        [matDatepicker]="OptionDate"
      />
      <mat-datepicker-toggle matSuffix [for]="OptionDate"></mat-datepicker-toggle>
      <mat-datepicker #OptionDate></mat-datepicker>
      @if (testBool && toolTipList.OPTIONDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.OPTIONDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.OPTIONDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Option Period</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.OPTIONPERIOD?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="OPTIONPERIOD"
      />
      @if (testBool && toolTipList.OPTIONPERIOD) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.OPTIONPERIOD.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.OPTIONPERIOD?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="100" class="pr-1">
      <mat-label>Option Desc.</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.OPTIONDESCRIPTION?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="OPTIONDESCRIPTION"
      />
      @if (testBool && toolTipList.OPTIONDESCRIPTION) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.OPTIONDESCRIPTION.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.OPTIONDESCRIPTION?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Reimb. For GST By Tenant</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.REIMBURSEMENTFORGSTBYTENANT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="REIMBURSEMENTFORGSTBYTENANT"
      />
      @if (testBool && toolTipList.REIMBURSEMENTFORGSTBYTENANT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.REIMBURSEMENTFORGSTBYTENANT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.REIMBURSEMENTFORGSTBYTENANT?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Stamp Duty Document</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.STAMPDUTYDOCUMENTS?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="STAMPDUTYDOCUMENTS"
      />
      @if (testBool && toolTipList.STAMPDUTYDOCUMENTS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.STAMPDUTYDOCUMENTS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.STAMPDUTYDOCUMENTS?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
</div>
